export const environment = {
  production: false,
  version: '1.0.0-dev',
  appName: 'Cine App (Development)',

  // API Configuration
  api: {
    baseUrl: 'https://supercines.witsoft.cc/api/web_v1',
    citiesEndpoint: 'https://supercines.witsoft.cc/api/web_v1/info/info.php',
    timeout: 30000, // 30 seconds
    retryAttempts: 3,
  },

  // Authentication
  auth: {
    tokenKey: 'cine_auth_token_dev',
    tokenExpiration: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
    refreshTokenKey: 'cine_refresh_token_dev',
  },

  // Storage
  storage: {
    userLocationKey: 'userLocation_dev',
    userPreferencesKey: 'userPreferences_dev',
    prefix: 'cine_dev_',
  },

  // Feature Flags
  features: {
    enableAnalytics: false,
    enablePushNotifications: false,
    enableOfflineMode: false,
    enableDebugMode: true,
  },

  // UI Configuration
  ui: {
    defaultLanguage: 'es',
    theme: 'default',
    itemsPerPage: 12,
    maxRetries: 3,
  },

  // External Services
  external: {
    googleMapsApiKey: '',
    analyticsId: '',
    sentryDsn: '',
  },
};
